import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { mapObjectMapValues } from "../../utils";
import { createProductDetailValidator } from "../products/SWBaseProductDetail";
/** @public */ /** @internal */ export const rootProductDetailVersions = {};
/** @internal */ export const rootProductDetailMigrations = defineMigrations({});
/** @public */ export function isProductDetail(record) {
    if (!record) return false;
    return record.typeName === "product_detail";
}
/** @public */ export function isProductDetailId(id) {
    if (!id) return false;
    return id.startsWith("product_detail:");
}
/** @internal */ export function createProductDetailRecordType(product_details) {
    return createRecordType("product_detail", {
        migrations: undefined,
        scope: "session",
        validator: T.model("product_detail", T.union("type", mapObjectMapValues(product_details, (type, { props, meta })=>createProductDetailValidator(type, props, meta))))
    }).withDefaultProperties(()=>({
            meta: {}
        }));
}
